import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user && user.role === "admin") {
      navigate("/admin", { replace: true });
    }
  }, [user, loading, navigate]);

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    const r = await login(email, password);
    setSubmitting(false);
    if (r.ok) {
      toast.success("Welcome back");
      navigate("/admin");
    } else {
      toast.error(r.error || "Login failed");
    }
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display text-2xl tracking-wider block text-center">
          BAD GIRL <span className="text-[#c8102e]">CUSTOMS</span>
        </Link>
        <div className="bgc-eyebrow text-center mt-8 text-[#c8102e]">ADMIN ACCESS</div>
        <h1 className="font-display text-5xl tracking-tight uppercase text-center mt-2">Log In.</h1>
        <form onSubmit={submit} className="mt-10 space-y-4 border border-white/10 p-8 bg-[#0a0a0a]">
          <label className="block">
            <span className="bgc-eyebrow block mb-2">Email</span>
            <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark w-full" />
          </label>
          <label className="block">
            <span className="bgc-eyebrow block mb-2">Password</span>
            <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark w-full" />
          </label>
          <button type="submit" disabled={submitting} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {submitting ? "SIGNING IN…" : "SIGN IN"}
          </button>
        </form>
        <Link to="/" className="block text-center text-xs text-[#9ca3af] hover:text-white mt-6 tracking-[0.2em] uppercase">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
